/**
 * Created by yuxin.zhang on 2017/11/7.
 */

import config from '../../config';
import getPageLink from '../../okjp/constants/PageLink';
import { getLegacyPageLink } from '../utils/userMigration';

const routePrefix = config.routePrefix;
const root = `/${routePrefix}`;
const account = `${root}/users`;
const balance = `${root}/balance`;

const sitePageLink = getPageLink(root, account, balance);

const { spotBillsRage, spotOrders, spotPage } = getLegacyPageLink();

const PageLink = {
  root: `${root}`,
  spotPage,
  otcPage: '/otc', // 法币交易
  futurePage: '/future/trade', // 合约交易
  etfPage: '/ett', // etf交易
  spotBillsRage, // 现货账单
  spotOrders,
  futureBillsRage: '/future/trade/bill', // 合约账单
  etfBillsRage: '/ett/bills', // 交易账单
  c2cSetting: '/otc/tradeSetting', // 法币交易设置

  walletPage: `${balance}/wallet`, // 我的钱包
  // 资金管理
  balance,
  myAssetsPage: balance, // 我的资产
  myTipsPage: `${balance}/wallet/tips`,
  spotAccountPage: `${balance}/transaction/spotAccount`, // 币币账户
  reportCenterPage: `${balance}/transaction/reportCenter`, // 订单中心
  fuAccountPage: `${balance}/transaction/fuAccount`, // 合约账户
  fiAccountPage: `${balance}/transaction/fiAccount`, // 法币账户
  etfAccountPage: `${balance}/transaction/ettAccount`, // etf账户
  /* rankingPage: `${balance}/ranking`, */

  rechargePage: `${balance}/wallet/recharge`, // 充币页面
  koDepositPage: `${balance}/wallet/KoDeposit`, // 韩元充值
  koDepositDetailPage: `${balance}/wallet/KoDeposit/DepositDetail/`, // 韩元充值详情

  withdrawPage: `${balance}/wallet/withdrawCurrency`, // 提币页面
  koWithdrawPage: `${balance}/wallet/KoWithdraw`, // 提币页面
  koWithdrawDetailPage: `${balance}/wallet/KoWithdraw/WithdrawDetail/`, // 韩元提现 详情

  cashDeposit: `${balance}/wallet/cashDeposit`,
  cashWithdraw: `${balance}/wallet/cashWithdraw`,

  mycardPage: `${balance}/card`, // 我的点卡页面
  cardPage: `${balance}/withdrawCard`, // 点卡转让页面
  walletBillsPage: `${balance}/wallet/AccountRecords`, // 钱包账单
  tipsBillsPage: `${balance}/wallet/tipsRecords`, // 钱包账单
  koDepositCardPage: `${balance}/wallet/KoDeposit/BindCard`, // 充值绑卡
  koWithdrawCardPage: `${balance}/wallet/KoWithdraw/BindCard`, // 充值绑卡

  miningDetailPage: `${balance}/mining`, // 挖矿明细
  earningsDoubledDetailPage: `${balance}/mining/earningsDoubled`, // 收益倍增
  encourageGoldDetailPage: `${balance}/mining/encourageGold`, // 鼓励金发放

  withdrawAddressPage: `${balance}/wallet/WithdrawCurrency/AddAddress`, // 提现添加地址
  cardAddressPage: `${balance}/card/addAddress`, // 点卡添加地址
  cardAddressRoutePage: `${balance}/card/addAddress/:isFrom/:isCard`, // 点卡添加地址

  addressManagement: `${balance}/wallet/AddAddress`,
  // 用户中心
  users: account,

  // 登录
  login: `${root}/login`,
  loginSecondVerify: `${root}/login/verify`,
  // 注册
  register: `${root}/register`,
  // 忘记登录密码
  forgetLoginPassword: `${root}/forgetLoginPwd`,

  // social login
  socialLoginBindAccount: `${root}/social-login/bind-account`,
  socialAccountRegister: `${root}/social-login/register`,

  // referral
  referral: `${root}/referral`,
  // join
  join: '/join/:invitationType/:invitationCode',
  // welcome
  welcome: '/welcome/:invitationType/:invitationCode?',

  // 販売所
  salePage: '/sale/:currency?',

  // 販売所行情
  saleMarket: `${root}/sale/:currency`,

  // 个人信息
  profile: account,
  // 安全中心
  security: `${account}/security`,
  // 子账号
  // subAccount: `${account}/subAccount`,
  // 批量创建 子账号
  // subAccountBatchAdd: `${account}/subAccountBatchAdd`,
  // 手续费等级
  fee: `${account}/fee`,
  // 市商计划
  marketMaker: `${account}/marketMaker`,
  // 我的收入
  income: `${account}/income`,
  // api
  myApi: `${account}/myApi`,
  // v3api
  myApiV3: `${account}/myApiV3`,

  // v1api
  myApiV1: `${account}/myApiV1`,
  // kyc认证
  verification: `${account}/verification`,
  // 忘记资金密码
  forgetTradePassword: `${account}/forgetTradePwd`,
  // 创建登录密码
  createLoginPassword: `${account}/login-pwd/create`,
  // 修改登录密码
  modifyLoginPassword: `${account}/login-pwd/modify`,
  // 资金密码
  tradePassword: `${account}/tradePwd/:type`,
  // 设置资金密码
  setTradePassword: `${account}/tradePwd/10`,
  // 修改资金密码
  modifyTradePassword: `${account}/tradePwd/20`,
  // 通行密钥列表
  passkey: `${account}/passkey`,
  // Email Setting
  emailSetting: `${account}/emailSetting`,
  // 谷歌
  google: `${account}/google/:type`,
  // 设置谷歌
  setGoogle: `${account}/google/10`,
  // 修改谷歌
  modifyGoogle: `${account}/google/20`,
  // 手机
  phone: `${account}/phone/:type`,
  // 设置手机
  setPhone: `${account}/phone/bind`,
  // 修改手机
  modifyPhone: `${account}/phone/edit`,
  // 邮箱
  email: `${account}/email/:type`,
  // 设置邮箱
  setEmail: `${account}/email/10`,
  // 修改邮箱
  modifyEmail: `${account}/email/20`,

  // 关联社交账户
  socialAccount: `${account}/social-account`,

  // 交易记录下载
  transactionRecord: `${balance}/reports/TransactionRecord`,
  // 日报告
  dayReport: `${balance}/reports/DayReport`,
  // 年报告
  yearReport: `${balance}/reports/YearReport`,
  // 月报告
  monthlyReport: `${balance}/reports/MonthlyReport`,
  // 法人课税调整
  corporateTaxationAdjustment: `${balance}/reports/corporateTaxationAdjustment`,
  // 赚币
  earnPage: `${balance}/earn`,
  // 资产分析
  analysis: `${balance}/analysis`,

  ...sitePageLink,
};

PageLink.config = {
  root,
  account,
  balance,
};

export default PageLink;
